const Flag = (props) => (
  <svg fill='none' height={21} width={20} xmlns='http://www.w3.org/2000/svg' {...props}>
    <g fill='currentColor'>
      <path d='M5.375 18.833a.63.63 0 0 1-.625-.625V2.79a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v15.417a.63.63 0 0 1-.625.625Z' />
      <path
        d='M12.666 6.468 5.916 3.55a.298.298 0 0 0-.3.025.309.309 0 0 0-.134.258v10.834c0 .108.059.208.15.266a.3.3 0 0 0 .167.05c.05 0 .092-.008.142-.033l6.916-3.417h.009c1.383-.716 2.125-1.641 2.083-2.616-.05-.984-.858-1.85-2.283-2.45Z'
        opacity={0.4}
      />
    </g>
  </svg>
);
export default Flag;
